export default __webpack_public_path__ + "static/media/13.bc0ac1ee.jpeg";